import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, LayoutDashboard, Users, FileText, BarChart3, LogOut, Moon, Sun, Plus, Settings as SettingsIcon, Key, Truck, Archive } from 'lucide-react';
import './Sidebar.css';

function Sidebar({
  isCollapsed,
  setIsCollapsed,
  onNewInvoice,
  isDarkMode,
  onToggleDarkMode,
  onLogout,
}) {

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="logo">
          <div className="logo-circle">
            <img src="/logo.png" alt="SSP Logo" className="logo-image" />
          </div>
          {!isCollapsed && <h2>SSP Billing</h2>}
        </div>
        <button className="toggle-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
          {isCollapsed ? <Menu size={20} /> : <X size={20} />}
        </button>
      </div>

      <nav className="sidebar-nav">
        <Link to="/" className="nav-item" title="Dashboard">
          <LayoutDashboard size={20} />
          {!isCollapsed && <span>Dashboard</span>}
        </Link>

        <button 
          className="nav-item new-invoice-btn" 
          onClick={onNewInvoice}
          title="Create New Invoice"
        >
          <Plus size={20} />
          {!isCollapsed && <span>New Invoice</span>}
        </button>

        <Link to="/customers" className="nav-item" title="Customers">
          <Users size={20} />
          {!isCollapsed && <span>Customers</span>}
        </Link>

        <Link to="/suppliers" className="nav-item" title="Suppliers">
          <Truck size={20} />
          {!isCollapsed && <span>Suppliers</span>}
        </Link>

        <Link to="/invoices" className="nav-item" title="Invoices">
          <FileText size={20} />
          {!isCollapsed && <span>Invoices</span>}
        </Link>

        <Link to="/purchases" className="nav-item" title="Purchases">
          <FileText size={20} />
          {!isCollapsed && <span>Purchases</span>}
        </Link>

        <Link to="/closing-stock" className="nav-item" title="Closing Stock">
          <Archive size={20} />
          {!isCollapsed && <span>Closing Stock</span>}
        </Link>

        <Link to="/reports" className="nav-item" title="Reports">
          <BarChart3 size={20} />
          {!isCollapsed && <span>Reports</span>}
        </Link>

        <Link to="/settings" className="nav-item" title="Settings">
          <SettingsIcon size={20} />
          {!isCollapsed && <span>Settings</span>}
        </Link>

        <Link to="/license" className="nav-item" title="License Management">
          <Key size={20} />
          {!isCollapsed && <span>License</span>}
        </Link>
      </nav>

      <div className="sidebar-footer">
        <button className="theme-toggle" onClick={onToggleDarkMode} title="Toggle Dark Mode">
          {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
          {!isCollapsed && <span>{isDarkMode ? 'Light' : 'Dark'}</span>}
        </button>

        <button className="logout-btn" title="Logout" onClick={onLogout}>
          <LogOut size={18} />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
